<template>
  <div v-if="isShowView" class="box">
    <div class="content">
      <div class="header_content">
        <div class="close_btn_content" @click="hideView">
          <img class="close_btn" src='@/static/images/close_icon.png' />
        </div>
        <div class="title_content">
          <p class="title">选择分组</p>
          <p class="sub_title">{{ fundName }}</p>
        </div>
        <div class="create_btn_content">
          <!-- <p class="create_btn">新建</p> -->
        </div>
      </div>
      <!-- 分组展示 -->
      <div class="scroll">
        <div v-for="(item, index) in groupList" :key="index">
          <div class="line"></div>
          <div class="cell_content" @click="chooseGroup(item.groupId)">
            <img
              class="choose_img"
              :src='selectedGroupList.indexOf(item.groupId) < 0 ? unSelectImg : selectImg'
            />
            <p class="group_name">{{ item.groupName }}</p>
          </div>
        </div>
      </div>
      <!-- 缺省展示 -->
      <div v-if="groupList.length == 0">
        <div class="line"></div>
        <div class="blank_content">
          <img class="blank_img" src="@/static/images/blank_group.png" />
          <p class="blank_text">暂无自定义分组</p>
        </div>
      </div>
      <div class="split"></div>
      <div class="sure_btn_content" @click="sureChangeAction">
        <img v-if="showLoading" class="refresh_img" src='@/static/images/gray_loading.gif' />
        <p v-else class="sure_text">确定</p>
      </div>
    </div>
  </div>
</template>

<script>
import selectImg from '@/static/images/manager_select.png';
import unSelectImg from '@/static/images/manager_no_select.png';
import options from '@/utils/options';

export default {
  data() {
    return {
      selectedGroupList: [],
      showLoading: false,
      isShowView: false,

      selectImg,
      unSelectImg,
      groupList: [],
      allGroupList: [],
      fundCode: '',
      fundName: '',
      originOptionGroup: [],
    };
  },

  mounted() {

  },

  methods: {
    showView(fundCode, fundName) {
      this.fundCode = fundCode;
      this.fundName = fundName;
      this.getGroupList();
      this.isShowView = true;
    },

    hideView() {
      this.isShowView = false;
    },

    async getGroupList() {
      try {
        const res = await options.getGroupList();
        const temp = await options.getFundGroupOptionList();
        this.originOptionGroup = [...(temp[this.fundCode] || [-1])];
        this.selectedGroupList = [...(temp[this.fundCode] || [-1])];
        this.groupList = [
          { groupName: '全部', groupId: -1 },
          ...(res || []).filter((item) => item.type !== 1),
        ];
        this.allGroupList = [...(res || [])];
      } catch (error) {
        this.groupList = [{ groupName: '全部', groupId: -1 }];
      }
    },

    // 选择分组
    chooseGroup(groupId) {
      const currentIndex = this.selectedGroupList.indexOf(groupId);
      if (currentIndex < 0) {
        this.selectedGroupList.push(groupId);
      } else {
        this.selectedGroupList.splice(currentIndex, 1);
      }
    },

    // 确认操作
    async sureChangeAction() {
      const { selectedGroupList, originOptionGroup } = this;
      // 选出主题分组
      const themeGroup = this.allGroupList
        .filter((item) => item.type === 1)
        .map((item) => item.groupId);
      // 过滤主题分组
      this.selectedGroupList = selectedGroupList.filter((item) => themeGroup.indexOf(item) < 0);
      // 无分组不可进行下去
      if (this.selectedGroupList.length === 0) {
        this.$feedback.showToast({ title: '请选择分组' });
        return;
      }
      // 分出删除分组和添加分组
      const addGroup = selectedGroupList.filter((item) => originOptionGroup.indexOf(item) < 0);
      const delGroup = originOptionGroup.filter((item) => selectedGroupList.indexOf(item) < 0);
      console.log('sureChangeAction', addGroup, delGroup);
      try {
        if (addGroup.length > 0) {
          await options.addFundOption(this.fundCode, this.selectedGroupList);
        }
        if (delGroup.length > 0) {
          await options.deleteFundOption(this.fundCode, delGroup);
        }
        this.hideView();
      } catch (error) {
        console.log('err', error);
        this.$feedback.showToast({ title: '操作失败' });
      }
    },
  },

};
</script>

<style scoped>
.box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  z-index: 10000;
}

.content {
  max-height: 80%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.header_content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 32px 0px;
}

.close_btn_content {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close_btn {
  width: 28px;
  height: 28px;
}

.title_content {
  align-items: center;
}

.title {
  font-size: 36px;
  color: #000000;
  text-align: center;
}

.sub_title {
  font-size: 28px;
  text-align: center;
  color: #666666;
  margin-top: 12px;
  max-width: 500px;
}

.create_btn_content {
  height: 88px;
  width: 120px;
  align-items: center;
  justify-content: center;
}

.create_btn {
  font-size: 32px;
  color: #008AFF;
}

.scroll {
  width: 100%;
  flex: 1;
  /* height: 100%; */
  overflow-x: hidden;
  overflow-y: scroll;
}

.line {
  width: 100%;
  height: 1px;
  background: #EEEEEE;
}

.cell_content {
  display: flex;
  flex-direction: row;
  padding: 30px;
  align-items: center;
}

.choose_img {
  width: 34px;
  height: 34px;
  margin-right: 20px;
}

.group_name {
  font-size: 32px;
  color: #000000;
}

.blank_content {
  align-items: center;
  justify-content: center;
  padding: 50px 0px;
}

.blank_img {
  width: 200px;
  height: 140px;
}

.blank_text {
  font-size: 30px;
  color: #999999;
  margin-top: 20px;
}

.split {
  width: 100%;
  height: 12px;
  background: #f5f5f5;
}

.sure_btn_content {
  width: 100%;
  height: 100px;
  background: #ffffff;
  align-items: center;
  justify-content: center;
}

.sure_text {
  font-size: 36px;
  color: #000000;
  line-height: 100px;
  text-align: center;
}

.refresh_img {
  width: 88px;
  height: 88px;
}
</style>
